module.exports = __webpack_public_path__ + "img/cleaar.2d043ee2.svg";